// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import "./assets/theme/index.css";
import Common from './Common'
import * as echarts from 'echarts'
import isMobile from '../static/isMobile'
Vue.prototype.$isMobile = isMobile


Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueAxios, axios)
Vue.prototype.Common = Common
Vue.prototype.$echarts = echarts
// Vue.axios.defaults.baseURL = "http://localhost:19005"
Vue.axios.defaults.baseURL = 'https://smart.mibee.cn'
Vue.axios.defaults.headers.post['Content-Type'] = 'application/json'
Vue.axios.defaults.transformRequest = function (data, headers) {
  var session = window.localStorage.getItem('sessionid')
  if (session) {
    if (!data) {
      data = {}
    }
    data.sessionid = session
  }
  return JSON.stringify(data)
}
Vue.axios.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    if (response.data.errcode === -2) {
      // response.data.errmsg="登录超时，请重新登录";
      router.push({ name: 'Login' });
    }
    return response
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error)
  }
)

// 路由拦截没有登录session信息，则跳转到登录界面
router.beforeEach((to, from, next) => {
  var session = window.localStorage.getItem('sessionid')
  if (to.name !== 'Login' && !session) next({ name: 'Login' })
  else next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js